package kz.dentalcrm.app.screens.protocols.list.mvi

import kz.dentalcrm.app.core.base.ViewEvent
import kz.dentalcrm.app.data.network.response_model.services.ServiceItem

sealed interface ProtocolsViewEvent : ViewEvent {

    data object Reload : ProtocolsViewEvent

    data class SearchProtocol(
        val search: String
    ) : ProtocolsViewEvent

    data class EditProtocol(
        val service: ServiceItem
    ): ProtocolsViewEvent

    data class DeleteProtocol(val id: Int) : ProtocolsViewEvent

    data object LoadMore : ProtocolsViewEvent
}